export const isAgentRoute = r => r.menu && !r.admin && !r.contentmanager && !r.supercontentmanager && !r.superadmin;
export const isAdminRoute = r => r.menu && r.admin;
export const isContentManagerRoute = r => r.menu && r.contentmanager;
export const isSuperAdminRoute = r => r.menu && r.superadmin;
